import * as React from "react";
import { PoshSelectRadioListItem } from "../../../misc/components/PoshSelectListItem";
import { SubjectLocation } from "../StartSessionWizardReducer";

interface WorkflowSelectionProps {
    location: SubjectLocation;
    onSelect: (location: SubjectLocation) => void;
    onRemote: () => void;
    onLocal: () => void;
    onBack: () => void;
}

export const WorkflowSelection = ({
    location,
    onSelect,
    onRemote,
    onLocal,
    onBack
}: WorkflowSelectionProps) => {
    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary">e-Diary Location</h2>
                    </div>
                    <div className="col-md-12">
                        <ul className="posh-select">
                            <PoshSelectRadioListItem
                                key="ItemRemote"
                                id="remoteAction"
                                title="Remote Configuration"
                                description="The e-diary is not located at the site and will be configured remotely"
                                icon="laptop-house"
                                isChecked={location === SubjectLocation.Remote}
                                onChange={() => onSelect(SubjectLocation.Remote)}
                            />
                            <PoshSelectRadioListItem
                                key="ItemLocal"
                                id="localAction"
                                title="Local Configuration"
                                description="Subject is present at the site with the e-diary, and the e-diary is connected via USB"
                                icon="clinic-medical"
                                isChecked={location === SubjectLocation.Local}
                                onChange={() => onSelect(SubjectLocation.Local)}
                            />
                        </ul>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" disabled={!location} onClick={location === SubjectLocation.Local ? onLocal : onRemote}>Next</button>
                <button className="btn btn-primary btn-outline" onClick={onBack}>Back</button>
            </div>
        </>
    );
};
